import { MealCountDto, MealCountStatus, DashboardCountStatus, ServingLineSummary } from '@/models';

export class MealCountStatusViewModel {
  constructor(
    public mealCount: MealCountDto,
    public countStatus: MealCountStatus | undefined) {
  }

  get hasReceivedData() {
    const rc = this.mealCount.receivedMeals;
    const received = !(rc.mealDeliveryDateTime === ''
      && rc.mealCountReceived === 0
      && rc.mealDeliveryTemperature === 0
      && rc.mealCountLeftoverPrevious === 0);

    return received;
  }

  get hasServedData() {
    const ls = new ServingLineSummary(this.mealCount.servingLines);
    
    const served = !(ls.firstMeal === 0
      && ls.secondMeal === 0
      && ls.adultProgramMeal === 0
      && ls.adultNonprogramMeal === 0
      && ls.mealCountLeftover === 0
      && ls.wastedMeal === 0
      && ls.incompleteMeal === 0
      && ls.additionalMealsRequested === 0);
    return served;
  }

  get dashboardModel() {
    const mealTypeId = this.mealCount.mealTypeId.toLowerCase();
    const affirmed = this.countStatus ? this.countStatus.hasAffirmedRevisions : false;
    const drafts = this.countStatus ? this.countStatus.hasDraftRevisions : false;

    return new DashboardCountStatus(mealTypeId, this.hasReceivedData, this.hasServedData, true, affirmed, drafts);
  }
}
